/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2022-12-07 16:56:14
 * @LastEditors: changfeng
 * @LastEditTime: 2023-06-07 15:07:25
 */
import { Reducer } from "@umijs/max";
export default {
  namespace: 'SHOPIFY',
  state: {
    reportParams:{}
  },
  reducers: {
    saveOrderReport(state, { payload }) {
      return {
        reportParams:payload
      };
    },
  },
};
